module.exports = new __parcel__URL__("step-deprecated-ones.cf47a65c.svg").toString();